export default class Booking {
  constructor(dom) {
    this.dom = dom;
    this.booking = dom.querySelector("#booking-datepicker");
    this.unitID;
    this.currentUnitID;
    this.bookingScheduleList = this.getSchedule(this.dom);
    this.currentSchedule ;
    this.datepicker;
    this.workshopduration = dom.getAttribute('data-duration');
    this.workshop_type_id = dom.getAttribute('data-workshop_type_id');
    this.bookingSummary;
    if(this.booking ){
      this.init();
    }

  }

  init(){
    if (this.booking) {
      const today = new Date();
      const startBookingDays = new Date(today.setDate(today.getDate())); // +1
      const endBookingDays = new Date(today.setDate(today.getDate() + 30));
      const classObj = this;
      this.datepicker = mobiscroll.datepicker(this.booking, {
        controls: ["calendar"],
        display: "inline",
        dateFormat:	'YYYY-MM-DD',
        returnFormat:'ISO 8601',
        min: startBookingDays,
        max: endBookingDays,
        onCellClick: function (event, inst) {
          let rawDate  = event.date.toISOString(); 
          // let trimIndex = rawDate.indexOf('T');
          // let selectedDate = rawDate.substring(0,trimIndex);
          // classObj.pickBookingDate(selectedDate);
          let tmpDate = String(event.date.getDate()).padStart(2, '0');
          let tmpMonth = String(event.date.getMonth()+1).padStart(2, '0');
          let selectedDate = event.date.getFullYear() + '-'+ (tmpMonth) + '-' + (tmpDate);
          classObj.pickBookingDate(selectedDate);
        },
      });
      let workshoptimeslots = this.dom.querySelectorAll('input[name=workshoptimeslot]');

      workshoptimeslots.forEach(function (el) {
        el.addEventListener('change',(e)=>{
          let location = classObj.currentUnitID;
          let bookingdate = classObj.dom.querySelector('#booking-datepicker').value;
          let startTime = el.value;
          let workshoplength = classObj.workshopduration;
          let timeslotBookID = classObj.workshop_type_id;
          console.log(classObj);
          if(location && bookingdate && startTime && workshoplength && timeslotBookID){
            let workshopObj = {};
            workshopObj.location = location ;
            workshopObj.bookingdate = bookingdate;
            workshopObj.startTime = startTime;
            workshopObj.workshoplength = workshoplength;
            workshopObj.timeslotBookID = timeslotBookID;  
            console.log(workshopObj);
            classObj.updateWooAddOnsConfig(workshopObj) ;
          }

        });
      });

    }
  }
  update(){
   if(this.unitID!=this.currentUnitID){
      this.currentUnitID = this.unitID;
      this.currentSchedule = [];
      let invalidList = [];
      let bookingSchedule = this.bookingScheduleList;
      
      // console.log(bookingSchedule);
      // console.log(this.currentUnitID);

      Object.entries(bookingSchedule).forEach(([key, value]) => {
        for(let list in value){
          if(list==this.currentUnitID){
            if(value[list].length===0){
              invalidList.push(key+"T12:00");
            }else{
              this.currentSchedule[key] = value[list];
            }
          }
        }
      });
      if(this.datepicker){
        this.datepicker.setOptions({invalid:invalidList});
      }
   }
  }
  getSchedule(dom){
    let resObj = {}; 
    if(dom.getAttribute('data-workshopschedule')){
      try {
        resObj = JSON.parse(dom.getAttribute('data-workshopschedule'));
      } catch (error) {
        console.error(error);
        resObj = {}; 
      }
    }
    return resObj;
  }
  getCurrentDate(){
    let d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }
  getCurrentHour(){
    let d = new Date(),
        hour = Number(d.getHours())*60 ,
        mins = Number(d.getMinutes());

    return hour+mins;
  }
  pickBookingDate(eventDate){
    const classObj = this;
    let todayDate = this.getCurrentDate();
    let currentTime =  this.getCurrentHour();
    console.log(todayDate);
    console.log(eventDate);
    
    classObj.updateWooAddOnsConfig();
    if(this.currentSchedule){
      if(this.currentSchedule.hasOwnProperty(eventDate)){
        let duration = Number(this.workshopduration );
        let workshoptimeslots = this.dom.querySelectorAll('input[name=workshoptimeslot]');
        let tmpDateTimeRange = this.currentSchedule[eventDate];

        workshoptimeslots.forEach(function (el) {
          let withinRange = false;
          let tmpStart = el.value.split(':'); 
          let tmpStartTotalMins = Number(tmpStart[0]*60)+Number(tmpStart[1]);
          let tmpEndTotalMins = tmpStartTotalMins + duration;

          el.checked = false;
          // console.log(tmpStartTotalMins+'//'+tmpEndTotalMins);

          Object.entries(tmpDateTimeRange).forEach(([key, value]) => {
            if(value.hasOwnProperty('from') && value.hasOwnProperty('to')){
              let avaliableStart  = value.from.split(':');
              let avaliableStartMins = Number(avaliableStart[0]*60)+Number(avaliableStart[1]);
              let avaliableEND  = value.to.split(':');
              let avaliableENDMins = Number(avaliableEND[0]*60)+Number(avaliableEND[1]);
              // console.log(avaliableStartMins+'//'+tmpStartTotalMins+'-'+tmpEndTotalMins+'//'+avaliableENDMins);
              if(avaliableStartMins <= tmpStartTotalMins && tmpEndTotalMins <= avaliableENDMins){
                withinRange = true;
                console.log('in range'+currentTime + ' // '+tmpStartTotalMins); // avaliableStartMins
                if(todayDate==eventDate && currentTime > tmpStartTotalMins){
                  withinRange = false;
                }
              }
            }
          });
          if(withinRange){
            el.disabled = false;
          }else{
            el.disabled = true;
          }
        });
      }
    }
  }

  updateWooAddOnsConfig(workshopObj) {

    let customOptionWrapper = this.dom.getAttribute("data-wooworkshop");
    let customsummaryfeild = document.querySelector("." + customOptionWrapper + " textarea.wc-pao-addon-field" );
    let clearWorkshopConfig = true;

    let locationWrapper = this.dom.getAttribute("data-location");
    let locationfeild = document.querySelector("." + locationWrapper + " input.wc-pao-addon-field" );
    

    if(workshopObj){
      if(workshopObj.hasOwnProperty('location') && 
        workshopObj.hasOwnProperty('bookingdate') &&
        workshopObj.hasOwnProperty('startTime') &&
        workshopObj.hasOwnProperty('workshoplength')){  

        console.log(customOptionWrapper);
        console.log(customsummaryfeild);

        console.log(locationWrapper);
        console.log(locationfeild);

        if(locationfeild){
          locationfeild.value = workshopObj.location;
        }

        if (customsummaryfeild) {
          customsummaryfeild.value = JSON.stringify(workshopObj);
          if(!this.dom.querySelector('input[name=leather_choice]:checked') && this.dom.querySelector('input[name=leather_choice]')) {
            this.dom.querySelector('input[name=leather_choice]').click(); 
          }
          this.dom.querySelector('.btn-workshop-step').classList.add('active');
          console.log(this.dom.querySelector('.btn-workshop-step'));
          let tempDatenTime = workshopObj.bookingdate +', <span>'+ workshopObj.startTime+'</span>';
          this.bookingSummary.update('booking',tempDatenTime);
          clearWorkshopConfig = false;
        }
      }
    }
    
    if(clearWorkshopConfig && customsummaryfeild){
      customsummaryfeild.value = '';
      this.dom.querySelector('.btn-workshop-step').classList.remove('active');
    }
  }
  

}
